import angular from 'angular';
import productsSelectorComponent from './productsSelector.component';

let productsSelectorModule = angular.module('productsSelector', []).directive('productsSelector', productsSelectorComponent);

export default productsSelectorModule;



// WEBPACK FOOTER //
// ./app/components/productsSelector/productsSelector.js